import { render, staticRenderFns } from "./LinkReports.vue?vue&type=template&id=857b3152"
import script from "./LinkReports.vue?vue&type=script&lang=js"
export * from "./LinkReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports